import { render, staticRenderFns } from "./CaculateQuota.vue?vue&type=template&id=262dddc4&scoped=true"
import script from "./CaculateQuota.vue?vue&type=script&lang=js"
export * from "./CaculateQuota.vue?vue&type=script&lang=js"
import style0 from "./CaculateQuota.vue?vue&type=style&index=0&id=262dddc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262dddc4",
  null
  
)

export default component.exports